import { ReactNode, useMemo } from "react"

import { FacetSpec } from "@vertesia/common"

import { DocumentSearch, DocumentSearchContext } from "@/plugins/providers/document/DocumentSearchContext"
import { useUserSession } from "@session/UserSession"

interface DocumentSearchProviderProps {
    children: ReactNode
    limit?: number
    facets?: FacetSpec[]
    collectionId?: string
}
export function DocumentSearchProvider({ children, limit, facets, collectionId }: Readonly<DocumentSearchProviderProps>) {
    const { store } = useUserSession()

    const search = useMemo(() => {
        const facetSpecs: FacetSpec[] = facets || []

        const search = new DocumentSearch(store, limit).withFacets(facetSpecs)
        search.collectionId = collectionId
        return search
    }, [limit])

    return (
        <DocumentSearchContext.Provider value={search}>{children}</DocumentSearchContext.Provider>
    )
}